import { createSlice } from "@reduxjs/toolkit";
import { getModuleById, getDefaultModule } from "../../config/modules";

const MODULE_STORAGE_KEY = "active_module";

// Load initial module from localStorage or use default
const loadInitialModule = () => {
  try {
    const storedModuleId = localStorage.getItem(MODULE_STORAGE_KEY);
    if (storedModuleId) {
      const module = getModuleById(storedModuleId);
      if (module && module.enabled) {
        return module.id;
      }
    }
  } catch (error) {
    console.error("Error loading module from localStorage:", error);
  }
  return getDefaultModule().id;
};

// Initial state
const initialState = {
  activeModuleId: loadInitialModule(),
};

// Module slice
const moduleSlice = createSlice({
  name: "module",
  initialState,
  reducers: {
    setActiveModule: (state, action) => {
      const moduleId = action.payload;
      const module = getModuleById(moduleId);
      
      if (module && module.enabled) {
        state.activeModuleId = moduleId;
        // Persist to localStorage
        try {
          localStorage.setItem(MODULE_STORAGE_KEY, moduleId);
        } catch (error) {
          console.error("Error saving module to localStorage:", error);
        }
      }
    },
    resetModule: (state) => {
      const defaultModule = getDefaultModule();
      state.activeModuleId = defaultModule.id;
      try {
        localStorage.setItem(MODULE_STORAGE_KEY, defaultModule.id);
      } catch (error) {
        console.error("Error resetting module in localStorage:", error);
      }
    },
  },
});

// Export actions
export const { setActiveModule, resetModule } = moduleSlice.actions;

// Export selectors
export const selectActiveModuleId = (state) => state.module.activeModuleId;
export const selectActiveModule = (state) => {
  return getModuleById(state.module.activeModuleId);
};

export default moduleSlice.reducer;

